import { render, staticRenderFns } from "./SurveyEditorArticle.vue?vue&type=template&id=b18ec87e&scoped=true"
import script from "./SurveyEditorArticle.vue?vue&type=script&lang=js"
export * from "./SurveyEditorArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18ec87e",
  null
  
)

export default component.exports